import moment from "moment";

const columns = [
    {
        title: 'Symbol',
        dataIndex: 'Symbol',
    },
    {
        title: 'Type',
        dataIndex: 'Type',
        render: (text) => text === 'BUY' ? <span className="text-[#28C76F] bg-[#DDF6E8] p-1 px-2 rounded font-semibold" >Buy</span> : <span className="text-[#FF4C51] bg-[#FFE2E3] p-1 px-2 rounded font-semibold" >Sell</span>,
    },
    {
        title: 'Volume',
        dataIndex: 'Volume',
    },
    {
        title: 'Open Price',
        dataIndex: 'PriceOpen',
        render: (text) => `$ ${text}`,
        width: 150,
    },
    {
        title: 'Current Price',
        dataIndex: 'PriceCurrent',
        render: (text) => `$ ${text}`,
        width: 150,
    },
    {
        title: 'S/L',
        dataIndex: 'StopLoss',
        render: (text) => `$ ${text}`,
    },
    {
        title: 'T/P',
        dataIndex: 'TakeProfit',
        render: (text) => `$ ${text}`,
    },  
    {
        title: 'Swap',
        dataIndex: 'Swap',
        render: (text) => `$ ${text}`,
    },
    {
        title: 'Open Time',
        dataIndex: 'Time',
        render: (text) => moment(text).format('DD-MM-YYYY LT'),
    },
    {
        title: 'P/L',
        dataIndex: 'Profit',
        render: (text) => text > 0 ? <span className="text-[#28C76F] font-semibold" >$ {text?.toFixed(2)}</span> : <span className="text-[#FF4C51] font-semibold" >$ {text?.toFixed(2)}</span>,
        width: 120,
    },
    {
        title: 'Close', dataIndex: 'close', key: 'close', width: 80
    }
];

export default columns;